import moment from 'moment';

import type { EdicaoWritePayload, EditionKind } from '../../services/admin';

/** Form values (datas como moment; o resto no formato dos inputs). */
export interface EdicaoFormValues {
  nome: string;
  subtitulo?: string;
  descricao?: string;
  dataPublicacao?: moment.Moment | null;
  valorAVista?: number | null;
  aVenda?: boolean;
  liberadaGratis?: boolean;
  torneioInicio?: moment.Moment | null;
  torneioFim?: moment.Moment | null;
  dificuldadesId?: number;
  author?: string;
  city?: string;
  state?: string;
  categoryIds?: number[];
  kind?: EditionKind;
}

const trimmed = (v?: string): string | undefined => {
  const t = v?.trim();
  return t ? t : undefined;
};

/** Monta o payload de escrita a partir dos valores do form (omite vazios). */
export function toPayload(v: EdicaoFormValues): EdicaoWritePayload {
  const payload: EdicaoWritePayload = { nome: v.nome.trim() };
  const subtitulo = trimmed(v.subtitulo);
  const descricao = trimmed(v.descricao);
  const author = trimmed(v.author);
  const city = trimmed(v.city);
  const state = trimmed(v.state);
  if (subtitulo !== undefined) payload.subtitulo = subtitulo;
  if (descricao !== undefined) payload.descricao = descricao;
  if (author !== undefined) payload.author = author;
  if (city !== undefined) payload.city = city;
  if (state !== undefined) payload.state = state;
  if (v.valorAVista != null) payload.valorAVista = Math.round(v.valorAVista * 100);
  if (v.dificuldadesId != null) payload.dificuldadesId = v.dificuldadesId;
  payload.aVenda = !!v.aVenda;
  payload.liberadaGratis = !!v.liberadaGratis;
  if (v.dataPublicacao) payload.dataPublicacao = v.dataPublicacao.toISOString();
  if (v.torneioInicio) payload.torneioInicio = v.torneioInicio.toISOString();
  if (v.torneioFim) payload.torneioFim = v.torneioFim.toISOString();
  payload.categoryIds = v.categoryIds ?? [];
  payload.kind = v.kind ?? 'DEFAULT';
  return payload;
}
